import type { ButtonHTMLAttributes, Ref } from "react";
import "./plain-button.css";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Arriva al `<button>` (in React 19 `ref` è una prop), per riportarvi il focus. */
  ref?: Ref<HTMLButtonElement>;
};

// Un pulsante senza aspetto proprio, per gli elementi cliccabili che sono un disegno e non un controllo: la cella
// di una mappa di calore, un blocco di un grafico, la voce della barra di navigazione che apre un pannello.
// Toglie i bordi, il fondo e i margini del browser e lascia il fuoco del sistema; l'aspetto lo dà la classe di chi
// lo usa. Per un'azione con testo si usa `Button`, per la riga di un elenco `OptionButton`, per la sola icona `IconButton`.
export function PlainButton({ type = "button", className, ...rest }: Props) {
  return <button type={type} className={className ? `g-plain-button ${className}` : "g-plain-button"} {...rest} />;
}
